<template lang="html">
  <div class="full-page">
    <i-header title="风险测评" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <div class="risk-result">
        <div class="risk-result-by">
          <div class="risk-result-info">
            <div class="risk-result-info-level">
              <div v-if="riskResult.evaluationResult !== '风险承受最低类别'" class="risk-blue-result">
                {{riskResult.evaluationResult}}
              </div>
              <div v-if="riskResult.evaluationResult === '风险承受最低类别'" class="risk-red-result">
                C1
              </div>
            </div>
            <div class="risk-result-info-btn">
              <cube-button @click="$_handleReStart" outline inline>重新测评</cube-button>
            </div>
            <div class="risk-result-info-desc">
              <div v-if="riskResult.evaluationResult !== '风险承受最低类别'">
                您适合购买等产品风险等级为{{riskResult.evaluationResult | fomateProductLevel}}的基金
              </div>
              <div v-if="riskResult.evaluationResult === '风险承受最低类别'">
                <span>风险承受最低类别，</span>您适合购买等产品风险等级为{{riskResult.evaluationResult | fomateProductLevel}}的基金
              </div>
            </div>
            <div class="risk-result-info-load">
              <i-load-more>重要声明</i-load-more>
            </div>
            <div class="risk-result-info-tips">
              重要声明：本风险属性评估问卷结果是根据您填写问卷当时所提供的个人资料而推论得知，
              且其结果将作为您未来在投资本公司基金产品时的参考所用。
              此问卷内容及其结果不构成与您进行交易之要约或要约之引诱，亦非投资买卖建议。
              妥妥递将不对此份问卷之准确性及资讯是否完整负责。
              您在此问卷上所填的个人资料本公司将予以保密。
            </div>
          </div>
          <div class="risk-result-no-match">

            <i-group-cell title="风险不匹配订单">
              <i-empty :show="noMatchOrder.length === 0" @click="$_getRiskNoMatchOrder"></i-empty>
              <i-cell
                v-for="(item, index) in noMatchOrder"
                :key="index"
                desc="签约成功"
                :level="item.newProductRisk">
                {{item.productName}}
              </i-cell>
            </i-group-cell>

          </div>
        </div>
        <div class="foot-btn">
          <cube-button @click="$_handleSubmit">提交</cube-button>
        </div>
      </div>
    </i-body>
  </div>


</template>

<script>
import { mapGetters } from 'vuex';
import { getRiskNoMatchOrder } from '../../api/risk';
import mixin from './config/signHandle';

export default {
  mixins: [mixin],
  data() {
    return {
      noMatchOrder: [],
    };
  },
  computed: {
    ...mapGetters(['riskResult', 'au', 'managerInfo']),
  },
  created() {
    this.$_getRiskNoMatchOrder();
  },
  methods: {
    /**
     * 获取风险不匹配订单
     * @return {[type]} [description]
     */
    $_getRiskNoMatchOrder() {
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      getRiskNoMatchOrder({
        plannerInvesterId: this.managerInfo.invenstemUserId,
        investerRiskLevel: this.riskResult.evaluationResult,
      }, this.au)
        .then((res) => {
          toast.hide();
          if (res.code === 0) {
            this.noMatchOrder = res.data.bean || [];
          } else {
            this.$createToast({
              type: 'txt',
              txt: res.msg,
              mask: true,
              time: 2000,
            }).show();
          }
        });
    },
    /**
     * 重新测评
     * @return {[type]} [description]
     */
    $_handleReStart() {
      this.$router.push({
        path: '/risk',
      });
    },
    $_handleSubmit() {
      if (this.managerInfo.sginQuestion) {
        // 需要签名
        this.$bridge.callHandler('sign', { msg: '用户签名', result: this.riskResult.evaluationResult }, () => {
        });
      } else {
        // 不需要签名
        this.$_handleRiskSave();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.risk-result {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .risk-result-by {
    overflow: auto;
    padding-bottom: 15px;
    .risk-result-info {
      padding: 20px 17px;
      background: #fff;
      text-align: center;
      .risk-result-info-level {
        margin-bottom: 16px;
        .risk-blue-result {
          display: inline-block;
          width: 88px;
          height: 88px;
          line-height: 88px;
          font-size: 32px;
          color: #2e6be6;
          font-weight: bold;
          background-image: url('../../assets/star_blue.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .risk-red-result {
          display: inline-block;
          width: 88px;
          height: 88px;
          line-height: 88px;
          font-size: 32px;
          color: #ff3838;
          font-weight: bold;
          background-image: url('../../assets/star_red.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
      .risk-result-info-btn {
        margin-bottom: 10px;
      }
      .risk-result-info-desc {
        margin-bottom: 10px;
        font-size: 13px;
        color: #2a2a2a;
        span {
          color: #ff3838;
        }
      }
      .risk-result-info-tips {
        text-align: left;
        font-size: 13px;
        color: #666;
      }
    }
    .risk-result-no-match {
      background: #fff;
      padding: 10px 0;
      margin-top: 15px;
    }
  }
}
</style>
